import React from 'react';

const PACKAGES = [100, 200, 500, 1000, 2000];

const RechargePackages = ({ selected, onSelect }) => (
  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, marginBottom: 16 }}>
    {PACKAGES.map((amt) => (
      <button
        key={amt}
        type="button"
        onClick={() => onSelect(amt)}
        style={{
          padding: '8px 18px',
          borderRadius: 20,
          border: '2px solid',
          borderColor: selected === amt ? '#6c5ce7' : '#dee2e6',
          background: selected === amt ? '#6c5ce720' : '#fff',
          color: selected === amt ? '#6c5ce7' : '#495057',
          fontWeight: 600,
          cursor: 'pointer',
          fontSize: 14,
          transition: 'all 0.15s',
        }}
      >
        ₹{amt}
      </button>
    ))}
  </div>
);

export default RechargePackages;
